import React, { useEffect } from 'react';
import { useAuth } from './contexts/AuthContext';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import StepWizard from './components/StepWizard'
import ReferralDashboard from './pages/ReferralDashboard';
import AuthPage from './pages/AuthPage';
import BetaAccessPage from './pages/BetaAccessPage';
import LeaderboardPage from './pages/LeaderboardPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

function App() {
  const { currentUser, authLoading, betaAccessVerified } = useAuth(); // Use currentUser and authLoading from context

  const PrivateRoute = ({ element }) => {
    if (authLoading) {
      // You can return a loading spinner here if you want a specific one for route changes
      // For now, returning null, consistent with AuthProvider's initial behavior
      return null;
    }
    if (!currentUser) {
      return <Navigate to="/auth" />;
    }
    if (!betaAccessVerified) {
      return <Navigate to="/beta-access" />;
    }
    return element;
  };

  const PublicRoute = ({ element }) => {
    if (authLoading) {
      return null;
    }
    return !currentUser ? element : <Navigate to="/" />;
  };

  const BetaAccessRoute = ({ element }) => {
    if (authLoading) {
      return null;
    }
    if (!currentUser) {
      return <Navigate to="/auth" />;
    }
    if (betaAccessVerified) {
      return <Navigate to="/" />;
    }
    return element;
  };

  // The top-level loading check (if (loading) return null;) is removed
  // because AuthProvider already handles not rendering children during initial auth load,
  // and PrivateRoute handles its own loading state during navigation.

  return (
    <Router>
      <Routes>
        <Route path="/" element={<PrivateRoute element={<StepWizard />} />} />
        <Route path="/auth" element={<PublicRoute element={<AuthPage />} />} />
        <Route path="/beta-access" element={<BetaAccessRoute element={<BetaAccessPage />} />} />
        <Route path="/referral" element={<PrivateRoute element={<ReferralDashboard />} />} />
        <Route path="/leaderboard" element={<PrivateRoute element={<LeaderboardPage />} />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
